import Connector from './connector';
import { LocalReportVersionsModal as Component } from './LocalReportVersionsModal';
import { ConnectorProps } from './LocalReportVersionsModal.prototypes';

interface LocalReportVersionsModalProps extends Omit<ConnectorProps, 'component'> {}

export const LocalReportVersionsModal = (props: LocalReportVersionsModalProps) => (
  <Connector reportId={props.reportId} reportName={props.reportName} component={Component} onClose={props.onClose} />
);
